import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

import { LogLevel } from '@amplitude/analytics-types';

interface Tracking {
  init: () => void;
  setUserId: (userId: number) => void;
  logoutUser: () => void;
  track: (...args: Parameters<typeof amplitude.track>) => void;
}

const tracking: Tracking = {
  init() {
    const sessionReplay = sessionReplayPlugin({
      sampleRate: 0.1,
    });
    amplitude.add(sessionReplay);
    amplitude.init(import.meta.env.VITE_AMPLITUDE_API_KEY, {
      autocapture: true,
      fetchRemoteConfig: true,
      logLevel: LogLevel.None,
    });
  },
  setUserId(userId: number) {
    amplitude.setUserId(`userId-${userId}`);
  },
  logoutUser() {
    amplitude.reset();
  },
  track(...args: Parameters<typeof amplitude.track>) {
    amplitude.track(...args);
  },
};

export default tracking;
